import * as t from 'io-ts';

import { iLiteral } from '@dmb/core';

// export enum ProductType {
//   Album = 'album',
//   EBook = 'ebook',
//   Movie = 'movie',
//   Series = 'series',
//   Season = 'season',
//   Track = 'track',
//   Episode = 'episode',
//   Physical = 'physical',
// }

const preDecoder = (input: unknown) => {
  if (input === 'serie') return 'series';
  if (input === 'phy-product') return 'physical';
  return input;
};

export const ProductTypeC = iLiteral(
  'Album',
  'EBook',
  'Movie',
  'Series',
  'Season',
  'Track',
  'Episode',
  'Physical',
).addPreprocessor(preDecoder);
export type ProductType = t.TypeOf<typeof ProductTypeC>;
export const ProductTypeLowerC = iLiteral(
  'album',
  'ebook',
  'movie',
  'series',
  'season',
  'track',
  'episode',
  'physical',
).addPreprocessor(preDecoder);
export type ProductTypeLower = t.TypeOf<typeof ProductTypeLowerC>;

export const typeToApiEndpoint = (i: unknown) => {
  const decoded = ProductTypeLowerC.decode(i);
  if (decoded._tag === 'Left') {
    return undefined;
  }

  const endpoint = decoded.right;

  if (endpoint === 'series') {
    return 'serie';
  }
  if (endpoint === 'ebook') {
    return 'book';
  }
  if (endpoint === 'physical') {
    return 'phy-product';
  }

  return endpoint;
};
